/** Zoho Creator map legend symbol values (mobile `NormalizedIcon`). */
export const SYMBOL_CIRCLE = "Circle";
export const SYMBOL_DIAMOND = "Diamond";
export const SYMBOL_HEXAGON = "Hexagon";
export const SYMBOL_SQUARE = "Square";
export const SYMBOL_STAR = "Star";
export const SYMBOL_TRIANGLE = "Triangle";
export const SYMBOL_LINE = "Line";
export const SYMBOL_DOTTED = "Dotted";
export const SYMBOL_DASHED = "Dashed";
export const SYMBOL_LONG_DASHED = "Long Dashed";

export const MAP_LEGEND_SYMBOLS = [
  SYMBOL_CIRCLE,
  SYMBOL_DIAMOND,
  SYMBOL_HEXAGON,
  SYMBOL_SQUARE,
  SYMBOL_STAR,
  SYMBOL_TRIANGLE,
  SYMBOL_LINE,
  SYMBOL_DOTTED,
  SYMBOL_DASHED,
  SYMBOL_LONG_DASHED,
] as const;

export type MapLegendSymbol = (typeof MAP_LEGEND_SYMBOLS)[number];

const SYMBOL_LOOKUP = new Map(
  MAP_LEGEND_SYMBOLS.map((symbol) => [symbol.toLowerCase(), symbol]),
);

/** Canonical symbol string for legend rows; defaults to pipeline line. */
export function normalizeMapLegendSymbol(raw: unknown): MapLegendSymbol {
  const text = typeof raw === "string" ? raw.trim() : "";
  if (!text) return SYMBOL_LINE;
  return (SYMBOL_LOOKUP.get(text.toLowerCase()) as MapLegendSymbol | undefined) ?? SYMBOL_LINE;
}

export function isMapLegendLineSymbol(symbol: MapLegendSymbol): boolean {
  return (
    symbol === SYMBOL_LINE ||
    symbol === SYMBOL_DOTTED ||
    symbol === SYMBOL_DASHED ||
    symbol === SYMBOL_LONG_DASHED
  );
}
